import {test} from 'ramda';

import {vinRegex} from '../constants/vinRegex';

export const validateVin = (vin: string) => test(vinRegex, vin);
